var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83539 6.01719C2.83404 6.04021 2.83335 6.0634 2.83335 6.08675V13.9128C2.83335 13.962 2.83639 14.0104 2.84229 14.0579L6.90538 9.91959C7.06467 9.75736 7.27403 9.67409 7.48471 9.67023L2.83539 6.01719ZM4.13672 4.92008L10.0174 9.54061L16.274 4.95244C16.1861 4.93129 16.0944 4.92008 16 4.92008H4.13672ZM17.1667 6.36459L12.7256 9.62139L17.1667 13.6924V6.36459ZM16.1956 15.0632L11.4369 10.701C11.4096 10.676 11.3844 10.6496 11.3612 10.622L10.4928 11.2588C10.1912 11.4799 9.77924 11.4731 9.48517 11.242L8.3133 10.3213C8.37272 10.5877 8.30016 10.8779 8.09466 11.0872L4.17498 15.0795H16C16.0667 15.0795 16.132 15.0739 16.1956 15.0632ZM1.16669 6.08675C1.16669 4.52195 2.43521 3.25342 4.00002 3.25342H16C17.5648 3.25342 18.8334 4.52194 18.8334 6.08675V13.9128C18.8334 15.4776 17.5648 16.7462 16 16.7462H4.00002C2.43521 16.7462 1.16669 15.4776 1.16669 13.9128V6.08675Z",
    fill: "#1E2632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4541dffbd85937d860d949ac5133a381.svg";
export { ForwardRef as ReactComponent };